import { useInjection } from "@linkfluence/core/di";
import { UserRepo, UserRepositoryUID } from "../repositories/UserRepo";

export function useCurrentUser() {
  return useInjection<UserRepo>(UserRepositoryUID).getCurrentUser();
}
